import CameraMinimalistic from '@/images/CameraMinimalistic.svg';
import { ScriptModal } from '@/pages/avatar/components/AvatarFootage/RecordWithWebcam/ScriptModal';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

const RecordWithWebcamContainer = styled.div`
    align-items: center;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.black[300]};
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
    width: 100%;
    height: 346px;
    transition: background linear 0.3s;
    cursor: pointer;

    &:hover {
        background: ${({ theme }) => theme.colors.black[100]};
    }
`;

const Image = styled.img`
    width: 116px;
    height: 116px;
    margin-block-end: 4px;
`;

const Badge = styled.div`
    font-size: 16px;
    color: ${({ theme }) => theme.colors.black[700]};
    background-color: ${({ theme }) => theme.colors.black[100]};
    border-radius: 8px;
    font-weight: 700;
    text-transform: capitalize;
    padding: 6px 8px;
`;

const UploadBoxMainText = styled.div`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.48px;
`;

const UploadBoxSubText = styled.div`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
`;

interface Props {
    onFileChange: (file: File | null) => void;
    badgeText?: string;
}

export const RecordWithWebcam = observer(({ onFileChange, badgeText }: Props) => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleOpen = () => {
        setModalOpen(true);
    };

    return (
        <>
            <RecordWithWebcamContainer onClick={handleOpen}>
                <Image src={CameraMinimalistic} />
                {badgeText && <Badge>{badgeText}</Badge>}
                <UploadBoxMainText>Record with webcam</UploadBoxMainText>
                <UploadBoxSubText>Read out a script and follow instructions</UploadBoxSubText>
            </RecordWithWebcamContainer>
            <ScriptModal open={modalOpen} setOpen={setModalOpen} onFileChange={onFileChange} />
        </>
    );
});
